import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { authSlice } from '@/redux/auth/auth';
import { dashboardSlice } from '@/redux/dashboard/dashboard';
import { ecommercePlatformSlice } from '@/redux/ecommerceWidget/ecommerceWidget';
import { merchantDataSlice } from '@/redux/merchant/merchant';
import { orderSlice } from '@/redux/orderManaged/orderManaged';
import { paymentCardSlice } from '@/redux/payment/paymentCardReducer';

import { commercialOffersSlice } from '../redux/commercialOffers/commercialOffers';
import { creditProposalSlice } from '../redux/eDniModal/creditProposal/creditProposal';
import { customerClassificationSlice } from '../redux/eDniModal/customerClassification/customerClassification';
import { dniSlice } from '../redux/eDniModal/dni/dni';
import { loanSimulationSlice } from '../redux/eDniModal/loanSimulation/loanSimulation';
import { productSlice } from '../redux/eDniModal/product/product';
import { errorSlice } from '../redux/error/error';
import { filterSlice } from '../redux/filters/filters';
import { notificationsSlice } from '../redux/notifications/notifications';
import { operationSlice } from '../redux/operation/operations';
import { settlementSlice } from '../redux/reporting/reporting';
import { chopIonicApp } from '../services/api';
import { invoiceSlice } from '@/redux/invoiceManaged/invoiceManaged';
import { cart } from 'ionicons/icons';
import { managedflowSlice } from '@/redux/invoiceManaged/cartIdManaged';
import { configSlice } from '@/redux/configOptions/config';

const dashboardPersistConfig = {
  key: 'dashboard',
  storage,
  whitelist: ['columns'],
};

const persistedDashboardReducer = persistReducer(dashboardPersistConfig, dashboardSlice.reducer);

export const rootReducer = combineReducers({
  [chopIonicApp.reducerPath]: chopIonicApp.reducer,
  operation: operationSlice.reducer,
  error: errorSlice.reducer,
  settlement: settlementSlice.reducer,
  commercialOffers: commercialOffersSlice.reducer,
  filters: filterSlice.reducer,
  product: productSlice.reducer,
  loanSimulation: loanSimulationSlice.reducer,
  creditProposal: creditProposalSlice.reducer,
  customerClassification: customerClassificationSlice.reducer,
  dniData: dniSlice.reducer,
  notifications: notificationsSlice.reducer,
  auth: authSlice.reducer,
  merchantData: merchantDataSlice.reducer,
  orderData: orderSlice.reducer,
  paymentCard: paymentCardSlice.reducer,
  ecommercePlatform: ecommercePlatformSlice.reducer,
  dashboard: persistedDashboardReducer,
  invoiceManaged: invoiceSlice.reducer,
  cartIdManaged: managedflowSlice.reducer,
  configSlice: configSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
    },
  }).concat(chopIonicApp.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
